import { render, staticRenderFns } from "./MastitisControlMeasures.vue?vue&type=template&id=75c18f64&"
import script from "./MastitisControlMeasures.vue?vue&type=script&lang=js&"
export * from "./MastitisControlMeasures.vue?vue&type=script&lang=js&"
import style0 from "./MastitisControlMeasures.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports